import A from "./a";
import B from "./b";

export default {
    A,
    B
};